export function isValidURL(str) {
  const regex   = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/g;
  const pattern = new RegExp(regex);

  return pattern.test(str);
}

export function isERPPage() {
  return window.location.pathname.includes('employee_referral_program');
}

export default { isValidURL, isERPPage };
